


  export const labels = {
    "dashboard": "Dashboard",
    "task": "Task",
    "file": "FileHub",
    "calendar": "Calendar",
    "workflows": "Workflows",
    "venue sales": "Sales",
    // "erpNext": "ERPNext",
    "expense": "Expense",
    "sales": "DAR",
  };

  export const iconMap = {
    "Dashboard": "dashboard_icon",
    "Task": "tasks_icon",
    "FileHub": "filehub_icon",
    "Calendar": "calendar_icon",
    "Workflows": "workflow_icon",
    "Sales": "sales_icons",
    // "ERPNext": "filehub_icon",
    "Expense": "workflow_icon",
    "DAR": "sales_icons",
  };